import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import lang from './lang'
import { getlangV2 } from 'src/helper/getlang'
import { history } from 'src/core/router'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.serviceStore = this.props.store.register('app/service')
  }
  state = {
    lang: lang.ar,
    language: 'en',
  }

  async componentWillMount() {
    console.log('componentWillMount')
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    this.setState({
      lang: lang[language] || lang.en,
    })
    let uid = await setUidToken(this.props.location.query)
    this.getFaqHotN()
    setDocumentTitle(this.state.lang.title)

    this.serviceStore.setFaqContent({
      id: 0,
      question: '',
      answer: '',
    })
  }

  async componentDidMount() {}

  componentDidUpdate() {
    console.log('componentDidUpdate')
    // let { qtype } = this.props.location.query
    // qtype = parseInt(qtype || 1)
    // if (qtype != this.serviceStore.data.qtype) {
    //   this.getFaqHotN()
    // }
  }

  getFaqHotN() {
    // let { qtype } = this.props.location.query
    // qtype = parseInt(qtype || 1)
    // if (qtype > 0) {
    // } else {
    //   qtype = 1
    // }
    this.serviceStore.setFaqHot({
      hasMore: true,
      scroll: '',
      list: [],
    })
    // this.serviceStore.setQtype(qtype)
    this.serviceStore.faqHot()
  }

  fqaList(list) {
    if (list && list.length > 0) {
      return (
        <div className="faqList">
          {list.map((item, index) => {
            return (
              <div
                className="item"
                onClick={() => {
                  this.displayFaqContent(item)
                }}
              >
                <img className="icon" src={`/img/app/service/ques.png`} />
                <div className="title">{item.question || ''}</div>
                <img className="arrow" src={`/img/app/service/arrow-right.png`} />
              </div>
            )
          })}
        </div>
      )
    }
  }

  displayFaqContent = (item) => {
    this.serviceStore.setFaqContent(item)
    history.push(`/app/service/faqContent?id=${item.id}`)
  }

  getFaqList(qtype) {
    // console.log('push', qtype)
    this.serviceStore.setFaqHot({
      hasMore: true,
      scroll: '',
      list: [],
    })
    // history.push(`/app/service?qtype=${qtype}`)
    this.serviceStore.setQtype(qtype)
    this.serviceStore.faqHot(qtype)
  }

  render() {
    let language = this.state.language
    // language = 'ar'
    let data = this.serviceStore.data
    let { faqHot, qtype } = data
    return (
      <div className={`service ${isRtl(language) && 'arlang'}`}>
        {faqHot.list.length == 0 && <img className="loadingGif" src={`/img/other/loading.gif`} />}
        {this.fqaList(faqHot.list)}

        <div style={{ height: '3.04rem' }}></div>

        {/* <div className={`bottom`}>
          <div className="items">
            <div
              className={`item ${qtype == 1 && 'active'}`}
              onClick={() => {
                this.getFaqList(1)
              }}
            >
              <img className="icon" src={`/img/app/service/q3.png`} />
              <div className="title">{this.state.lang.Accounts}</div>
            </div>
            <div
              className={`item ${qtype == 2 && 'active'}`}
              onClick={() => {
                this.getFaqList(2)
              }}
            >
              <img className="icon" src={`/img/app/service/q2.png`} />
              <div className="title">{this.state.lang.operate}</div>
            </div>
            <div
              className={`item ${qtype == 3 && 'active'}`}
              onClick={() => {
                this.getFaqList(3)
              }}
            >
              <img className="icon" src={`/img/app/service/q1.png`} />
              <div className="title">{this.state.lang.roomP}</div>
            </div>
            <div
              className={`item ${qtype == 4 && 'active'}`}
              onClick={() => {
                this.getFaqList(4)
              }}
            >
              <img className="icon" src={`/img/app/service/q4.png`} />
              <div className="title">{this.state.lang.Other}</div>
            </div>
          </div>
          <div
            className={`feedback`}
            onClick={() => {
              history.push(`/app/service/feedback`)
              // 是否显示举报
              this.serviceStore.handleRpIsShow(false)
            }}
          >
            <img
              className="icon"
              src="/img/app/service/feedback.png"
            />
            <div className="title">{this.state.lang.Feedback}</div>
          </div>
        </div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/index.js